export const SIGN_IN = '/login';
export const FORGOTTEN_PASSWORD = "/forgottenPassword"
export const LANDING = '/landing';
export const SIGN_UP = '/signup';
export const HOME = '/home';
export const ACCOUNT = '/account';
export const MANAGER = '/manager';
export const TEAM = '/team';
export const PEERS = '/peers';
export const DRIVING = '/driving';
export const SEARCH = '/search';
export const CHALLENGE = '/challenge';
export const CREATECAPSULE = '/CreateCapsule';
export const RECEIVED = '/received';
export const EMAIL_VERIF = "/email";